var map = {
	".": 42,
	"./": 42,
	"./Groupgg.png": 338,
	"./Icono 11.svg": 656,
	"./arrow-right.png": 339,
	"./check.svg": 340,
	"./error.svg": 341,
	"./happyface.svg": 342,
	"./icono1.svg": 343,
	"./icono2.svg": 657,
	"./icono2gris.svg": 658,
	"./icono3.svg": 659,
	"./icono3gris.svg": 660,
	"./icono4.svg": 661,
	"./icono4gris.svg": 662,
	"./index": 42,
	"./index.jsx": 42,
	"./ok.svg": 344,
	"./sadface.svg": 345
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;